import type { FC } from 'react';

import Button from '@helsenorge/designsystem-react/components/Button';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';

interface Props {
  buttonText: string;
}

export const Innloggingsknapp: FC<Props> = ({ buttonText }) => {
  return (
    <>
      <Button htmlMarkup="a" className="page-helseregistre__login" href={`/auth/signin?Source=${encodeURIComponent(window.location.href)}`}>
        {buttonText}
      </Button>
      <Spacer size="l" />
    </>
  );
};
